import { computed } from 'vue'

export const ScreenOrientation = {
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait'
} as const

const useScreenOrientation = () => {
  const orientation = computed(() =>
    window.innerWidth > window.innerHeight
      ? ScreenOrientation.LANDSCAPE
      : ScreenOrientation.PORTRAIT
  )

  return {
    orientation
  }
}

export { useScreenOrientation }
